export default function Hero() {
  return (
    <section id="top" data-testid="hero-section" className="bg-[#EBEBFA] overflow-hidden">
      <div className="max-w-6xl mx-auto md:grid md:grid-cols-2 md:items-stretch">
        <div className="px-6 md:px-10 py-16 md:py-28 flex flex-col justify-center">
          <p className="rise-in rise-in-1 text-sm font-bold tracking-widest uppercase text-[#2D3748]/70 mb-5">
            Ready &amp; Right Testing Services · Since 1996
          </p>
          <h1 className="rise-in rise-in-2 text-4xl sm:text-5xl lg:text-6xl leading-[1.08] text-[#1A243B] mb-6">
            Homeschool testing in Oregon &amp; Washington,<br />done <span className="italic">right</span>.
          </h1>
          <p className="rise-in rise-in-3 text-base md:text-lg text-[#2D3748] leading-relaxed max-w-md mb-10">
            Calm, in-person TerraNova testing at your home or co-op, from an ODE-approved tester with 30 years' experience. Serving Portland metro, Southwest Washington, the Willamette Valley and the North Coast, and happy to travel farther (a travel fee may apply).
          </p>
          <div className="rise-in rise-in-4 flex flex-wrap items-center gap-6 mb-6">
            <a data-testid="hero-book-btn" href="#book" className="cta-pill inline-block bg-[#FFC107] text-[#1A243B] font-bold px-8 py-3.5 rounded-full text-base">
              Book a testing date
            </a>
            <a data-testid="hero-grades-link" href="#faqs" className="text-[#1A243B] font-bold underline underline-offset-4 decoration-[#FFC107] decoration-2 hover:opacity-70 transition-opacity">
              Which grades need testing? →
            </a>
          </div>
          <p className="rise-in rise-in-4 text-sm font-semibold text-[#2D3748]/70" data-testid="hero-trust-line">
            ODE-approved tester · Nationally normed, state-approved tests · Nearly 30 years serving Oregon families.
          </p>
        </div>
        <div className="relative min-h-[320px] md:min-h-0">
          <img
            src="/images/hero-crafts.png"
            alt="A child's hands arranging colourful paper shapes at a homeschool desk"
            data-testid="hero-image"
            className="torn-right absolute inset-0 w-full h-full object-cover"
          />
        </div>
      </div>
    </section>
  );
}
